import { HeadlessUI } from '@systemeio/ui'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface PageTabProps extends Record<string, unknown> {
  children: React.ReactNode
  className?: string
}

export const PageTab = ({ children, className, ...props }: PageTabProps) => {
  return (
    <HeadlessUI.Tab
      className={({ selected }) =>
        twMerge(
          `main-transition-colors w-fit px-4 pb-6 pt-6 outline-hidden sm:px-5`,
          selected
            ? 'text-text-primary border-b-brand-primary border-b-2'
            : 'border-b-2 border-b-transparent',
          className,
        )
      }
      {...props}
    >
      <span className="font-inter whitespace-nowrap font-bold sm:text-[17px]">{children}</span>
    </HeadlessUI.Tab>
  )
}
